const config = {
  default: {
    name: "Trackmydoc",
    domainName: "trackmydoc.com",
    intractName: "Trackmydoc",
    intractEmail: "trackmydoc@gmail.com",
    firmType: "cpa",
  },
  "northernimmigration.co.in": {
    name: "Northern Immigration",
    domainName: "northernimmigration.co.in",
    logo: "/assets/logo/logo.png",
    favicon: "/assets/logo/favicon.ico",
    intractName: "Northern Immigration",
    intractEmail: "northernimmigration.ca@gmail.com",
    firmType: "immigration",
  },
};

const getSiteConfig = () => {
  const hostname = window.location.hostname;
  const matchedKey = Object.keys(config).find((key) => hostname.includes(key));
  return config[matchedKey] || config["default"];
};

const siteConfig = getSiteConfig();

export default siteConfig;
